import { ReactNode } from 'react';
import { useBackoffice } from './useBackoffice';
import { DeveloperAccountSelectPanel } from './DeveloperAccountSelectPanel';

interface WithDeveloperPageProps {
  children: ReactNode;
}

export const WithDeveloperAccountPage = ({ children }: WithDeveloperPageProps) => {
  const { isBackofficeOn, developerId } = useBackoffice();

  if (!isBackofficeOn) {
    return <>{children}</>;
  }

  return (
    <div>
      <DeveloperAccountSelectPanel />
      {!!developerId && children}
    </div>
  );
};
